import { InlineLoading, Loading, SkeletonText as CarbonSkeletonText } from '@carbon/react';
import type { ComponentProps } from 'react';

export interface CdSpinnerProps {
  /** Accessible description of what is loading. */
  label?: string;
  /** `inline` renders a small spinner with text next to it. */
  variant?: 'overlay' | 'small' | 'inline';
}

export const CdSpinner = ({ label = 'Loading', variant = 'small' }: CdSpinnerProps) => {
  if (variant === 'inline') return <InlineLoading description={label} />;
  return (
    <Loading description={label} small={variant === 'small'} withOverlay={variant === 'overlay'} />
  );
};

export type CdSkeletonTextProps = ComponentProps<typeof CarbonSkeletonText>;

/** Placeholder lines while content loads. */
export const CdSkeletonText = (props: CdSkeletonTextProps) => {
  return <CarbonSkeletonText {...props} />;
};
